module.exports = __webpack_public_path__ + "static/media/hiking.9cbc0ad3.jpg";